import React, { lazy, Suspense } from "react";
import { css } from "@linaria/core";

import { type BlockPresetModelT } from "../../../../../schema/block/preset";
import AverageLossesWidget from "../../../../../../Widget/AverageLossesWidget";
import PriorityEventWidget from "../../../../../../Widget/PriorityEventWidget";
import ProductionMonitoringWidget from "../../../../../../Widget/ProductionMonitoringWidget";
import FinancialImpactWidget from "../../../../../../Widget/FinancialImpactWidget";
import ErrorBoundary from "../../../../../../../ErrorBoundary";
import { BasenameContext } from "../../../../../../../../router/helpers/navigation";
import { MTS_ENV } from "../../../../../../../../lib/setupEnv";
import { BlockLoading } from "../Loading";

// @ts-ignore
const AnomalyDetectionBasenameProvider = lazy(() => import("anomaly_detection/basename-provider"));
const AnomalyDetectionLastWeekAlerts = lazy(
  // @ts-ignore
  () => import("anomaly_detection/last-week-alerts-table"),
);

export const BlockPreset = React.memo(
  ({
    projectId,
    projectTimezone,
    powerUnitId,
    block,
  }: {
    projectId: string;
    projectTimezone: string;
    powerUnitId?: string | null;
    block: BlockPresetModelT;
  }) => {
    switch (block.data.preset) {
      case "AVERAGE_LOSSES":
        return (
          <BasenameContext.Provider value={MTS_ENV.OSS_INTEGRATION ? "/diagnostics/" : "/"}>
            <AverageLossesWidget
              className={widget}
              projectId={projectId}
              projectTimezone={projectTimezone}
              hideLink={false}
              sharedAggregationPeriod={false}
              disablePeriod
            />
          </BasenameContext.Provider>
        );

      case "PRODUCTION_MONITORING":
        return (
          <BasenameContext.Provider value={MTS_ENV.OSS_INTEGRATION ? "/diagnostics/" : "/"}>
            {/* // if no qoi we need to not render this */}
            <ProductionMonitoringWidget
              className={widget}
              projectId={projectId}
              projectTimezone={projectTimezone}
              disablePeriod
              hideLink={false}
            />
          </BasenameContext.Provider>
        );

      case "PRIORITY_FAULT_EVENTS":
        return (
          <BasenameContext.Provider value={MTS_ENV.OSS_INTEGRATION ? "/diagnostics/" : "/"}>
            <PriorityEventWidget
              className={widget}
              projectId={projectId}
              systemIds={block.data.systemIds}
            />
          </BasenameContext.Provider>
        );

      case "FINANCIAL_IMPACT":
        return (
          <FinancialImpactWidget
            className={widget}
            projectId={projectId}
            scope={`${projectId}-${block.dashboardId}`}
          />
        );
      case "ANOMALY_DETECTION_LAST_WEEK_ALERTS":
        return (
          <ErrorBoundary>
            <Suspense fallback={<BlockLoading />}>
              <AnomalyDetectionBasenameProvider basename="/anomaly-detection">
                <AnomalyDetectionLastWeekAlerts powerUnitIds={powerUnitId ? [powerUnitId] : []} />
              </AnomalyDetectionBasenameProvider>
            </Suspense>
          </ErrorBoundary>
        );

      default: {
        console.debug("Unknown preset value");
        return null;
      }
    }
  },
);

const widget = css`
  min-width: 400px;
  max-width: none;
  min-height: auto;
  border: initial;
  padding: initial;
`;
